
import type { PropOptions } from 'vue';
import Vue from 'vue';

interface Data {
  selected: Array<string>;
}

export default Vue.extend({
  name: 'JobsSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Array],
      default: () => [],
    } as PropOptions<string | Array<string>>,
    multiple: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  data(): Data {
    return {
      selected: [],
    };
  },
  computed: {
    currentValue(): Array<string> {
      return (this.multiple ? this.value : [this.value]) as Array<string>;
    },
  },
  methods: {
    isSelected(option: string) {
      return this.currentValue.map(value => String(value)).includes(option);
    },
    handleToggle(option: string) {
      let newValue: Array<string> | string = [];
      if (this.multiple) {
        newValue = this.currentValue.includes(option)
          ? this.currentValue.filter(v => v !== option)
          : [...this.currentValue, option];
      } else {
        newValue = option;
      }
      this.$emit('change', newValue);
    },
  },
});
